import { observer } from 'mobx-react-lite'
import cn from 'classnames'

import { EventIcon, TextArea } from 'components'
import { useValueContext } from 'contexts'
import { FlexLayout } from 'layouts'
import { EventType } from 'types'

import { CurrentDateError, Duration, TimeInputs } from '../../components'
import { iconProps } from '../consts'
import './styles.scss'

interface Props {
  current?: boolean
}

export const Breast = observer(({ current }: Props) => {
  const { eventStore } = useValueContext()
  const { type, event, setType, setEventField, validFunctions } = eventStore

  const isDurationValid = validFunctions[EventType.BREAST_LEFT]

  return (
    <>
      <div className="page-title event-title">ГВ</div>

      <FlexLayout.Content className="scrollable-layout event-scrollable" scrollable>
        <div className="breast-event">
          <div className="type-icons">
            <EventIcon
              iconName="BreastLeftIcon"
              {...iconProps}
              onClick={() => setType(EventType.BREAST_LEFT)}
              className={cn('change-event-icon', {
                'breast-inactive': type !== EventType.BREAST_LEFT,
              })}
            />
            <EventIcon
              iconName="BreastRightIcon"
              {...iconProps}
              onClick={() => setType(EventType.BREAST_RIGHT)}
              className={cn('change-event-icon', {
                'breast-inactive': type !== EventType.BREAST_RIGHT,
              })}
            />
          </div>
          <div
            className="type-name"
            style={{
              color:
                type === EventType.BREAST_LEFT ? 'var(--red-primary)' : 'var(--green-tertiary)',
            }}
          >
            {type === EventType.BREAST_LEFT ? 'Левая' : 'Правая'}
          </div>
          <div className="breast-form">
            <div className="time-grid">
              <TimeInputs
                label="Начало"
                value={event?.startTime}
                onChange={(value: string) => setEventField('startTime', value)}
                selectTimeOnRender={current}
                eventType="START"
              />
              <CurrentDateError />
              {!current && (
                <>
                  <TimeInputs
                    label="Конец"
                    value={event?.endTime}
                    onChange={(value: string) => setEventField('endTime', value)}
                    eventType="END"
                  />
                  <Duration
                    isValid={isDurationValid()}
                    startTime={event?.startTime}
                    endTime={event?.endTime}
                  />
                </>
              )}
            </div>
            <TextArea
              className="event-textarea"
              label="Комментарий"
              value={event?.comment}
              onChange={(value: string) => setEventField('comment', value)}
              scrollToOnFocus
            />
          </div>
        </div>
      </FlexLayout.Content>
    </>
  )
})
